import type { ComponentProps } from "react";
import { cn } from "../../utils/format";

type CardProps = ComponentProps<"div"> & {
  tone?: "dark" | "cream";
};

export const Card = ({ tone = "dark", className, ...props }: CardProps) => (
  <div
    className={cn(
      "rounded-card",
      tone === "dark" ? "border border-line bg-card" : "bg-cream text-night",
      className,
    )}
    {...props}
  />
);
